import { useNavigate } from 'react-router';
import { toast } from '@lib/ui';
import type { WizardPersona } from '../types';
import { StepByStepWizard } from './index';

export default function StepByStepWizardPage() {
  const navigate = useNavigate();

  const handleComplete = (persona: WizardPersona) => {
    toast.success(`Persona "${persona.name}" created successfully!`);
    navigate('/personas');
  };

  const handleCancel = () => {
    navigate('/poc/wizards');
  };

  return <StepByStepWizard onComplete={handleComplete} onCancel={handleCancel} />;
}
